/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import {ModelBase} from "./model-base";
import {IModelBase} from "./i-model-base";
import {ConfigurationNl} from "./configuration-nl";
import {SalaryModifier} from "../_modules/location/_models/salary-modifier";

export class LocationDto extends ModelBase implements IModelBase {
  configuration: ConfigurationNl = new ConfigurationNl();
  showConfig: string = "none";
  receivesTips: boolean = true;
  order: number = 0;
  defaultEmployeeCount: number = 0;
  defaultChangeAmount: number = 0;
  salaryModifier: SalaryModifier | undefined;
}
